import React from 'react';

export default () => (
  <div>
    <h4>404</h4>
    <h5>The route your looking for does not exist</h5>
  </div>
);
